import { render, staticRenderFns } from "./live-edit.vue?vue&type=template&id=052ef909&scoped=true&"
import script from "./live-edit.vue?vue&type=script&lang=js&"
export * from "./live-edit.vue?vue&type=script&lang=js&"
import style0 from "./live-edit.vue?vue&type=style&index=0&id=052ef909&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052ef909",
  null
  
)

export default component.exports